import React, { useEffect, useState } from 'react'

import { Button, Card, Col, Icon, Input, Row, Select, Table, Typography } from 'antd'

import { CustomBreadcrumb } from '../../components/CustomBreadcrumb/CustomBreadcrumb'
import { TableLineDisable } from '../../components/TableLineDisable/TableLineDisable'
import { RULES, validRule } from '../../constants/Entitlements'
import { api, request } from '../../util/handlerRequestUtil'
import { getMessage } from '../../util/IntlMessages'

import './journeyStyles.css'

const ListJourney = function ({ match, history }) {
  const [formatedData, setFormatedData] = useState([])
  const [organization, setOrganization] = useState('')
  const [description, setDescription] = useState('')
  const [formattedOrganizations, setFormattedOrganizations] = useState([])

  // Created component
  useEffect(() => {
    const hasAccess = validRule(RULES.ACTION_TEMPLATE) // Não deixa acessar a tela
    if (!hasAccess) {
      return history.push('/home')
    }
    fetchData()
  }, [])

  // Api requests
  async function fetchData(params) {
    try {
      const items = await request(api.listOrganizations({}), true)
      const values = items.reduce((acc, { id, name }) => [...acc, { value: id, description: name }], [])

      setFormattedOrganizations(values)

      const { data } = await request(api.listActionTemplates(params))

      const formatedRows = data.map((item) => ({
        key: item.id,
        ...item,
        templateName: item.name,
        organizationName: values.find((i) => i.value == item.organizationId).description,
        status: formatStatus(item.templateStatus),
        actions: formatActionsContent(item.id)
      }))

      setFormatedData({
        ...data,
        items: formatedRows
      })
    } catch (error) {
      console.tron.log('error', error)
    }
  }

  async function handleCleanFilters() {
    setDescription('')
    setOrganization('')
    await fetchData()
  }

  const formatStatus = (status) => {
    const statusData = {
      PENDENTE: { className: 'warning', content: getMessage('template.list.status.pending') },
      EXECUTADA: { className: 'success', content: getMessage('template.list.status.finished') }
    }
    const { className, content } = statusData[status] || {}
    return className && content ? <div className={`mxi-status-badge ${className}`}>{content}</div> : null
  }

  function sortText(a, b, field) {
    if (a !== null && a[field] !== null && b !== null && b[field] !== null && field !== null) {
      if (a[field] < b[field]) return -1
      if (a[field] > b[field]) return 1
    }

    return 0
  }

  const columns = [
    {
      title: getMessage('description'),
      dataIndex: 'templateName',
      width: '50%',
      sorter: (a, b) => sortText(a, b, 'templateName'),
      render: (item, line) => <TableLineDisable item={item} line={line} />
    },
    {
      title: getMessage('organization'),
      dataIndex: 'organizationName',
      width: '20%',
      sorter: (a, b) => sortText(a, b, 'organizationName'),
      render: (item, line) => <TableLineDisable item={item} line={line} />
    },
    {
      title: getMessage('actions.table.field.status'),
      dataIndex: 'status',
      width: '20%',
      render: (item, line) => <TableLineDisable item={item} line={line} />
    },
    {
      title: getMessage('edit'),
      dataIndex: 'actions',
      width: '10%'
    }
  ]

  function onChange(pagination) {
    const { current } = pagination
    fetchData({ page: current - 1 })
  }

  const formatActionsContent = (id) => (
    <Button
      className="default-actionContent-button"
      type="link"
      onClick={() => {
        history.push(`/journeys/${id}`)
      }}
    >
      <Icon type="edit" className="default-actionContent-icon" />
    </Button>
  )

  function renderHeader() {
    const hasAccess = validRule(RULES.ACTION_TEMPLATE) // Remove o botão "novo"
    return (
      <div className="default-header-div">
        <div className="default-header-breadcrumb">
          <CustomBreadcrumb match={match} history={history} />
          {hasAccess && (
            <Button
              className="default-header-button button-action"
              type="primary"
              onClick={() => history.push('/journeys/create')}
            >
              {getMessage('createJorney')}
            </Button>
          )}
        </div>
      </div>
    )
  }

  function getColumns() {
    const hasAccess = validRule(RULES.ACTION_TEMPLATE) // Remove o lapis da lista
    if (hasAccess) {
      return columns
    }

    if (columns !== null) {
      columns.pop()
      return columns
    }
  }

  return (
    <>
      {renderHeader()}

      <Card className="ant-card gx-card ant-card-bordered">
        <Row>
          <Col span={6}>
            {getMessage('actions.list.field.filterDescription')}
            <Input
              value={description}
              className="default-header-search"
              onChange={(e) => setDescription(e.target.value)}
            />
          </Col>

          <Col span={6}>
            {getMessage('filterOrganization')}
            <Col>
              <Select className="organization-select" value={organization} onChange={setOrganization}>
                {formattedOrganizations.map((obj) => (
                  <Select.Option value={obj.value} key={obj.value}>
                    {obj.description}
                  </Select.Option>
                ))}
              </Select>
            </Col>
          </Col>
        </Row>

        <div className="horizontal-line" style={{ margin: '20px 0px 20px' }} />

        <Row type="flex" justify="start">
          <Col span={14} />
          <Col span={5}>
            <Button
              icon="search"
              className="bgPrimary"
              style={{ width: '100%' }}
              type="dashed"
              onClick={() =>
                fetchData({
                  name: description,
                  organizationId: organization
                })
              }
            >
              {getMessage('search')}
            </Button>
          </Col>
          <Col span={5}>
            <Button
              icon="close"
              style={{
                width: '100%',
                borderColor: '#EE778F',
                color: '#EE778F'
              }}
              type="ghost"
              onClick={handleCleanFilters}
            >
              {getMessage('cleanFilters')}
            </Button>
          </Col>
        </Row>

        <Typography.Title className="default-header-title" level={3}>
          {getMessage('listJourneys')}
        </Typography.Title>
        <Table key="id" columns={getColumns()} dataSource={formatedData.items} onChange={onChange} pagination={false} />
      </Card>
    </>
  )
}

export default ListJourney
